type UseProductNameShort = () => string;
export const useProductNameShort: UseProductNameShort = () => 'Engage';
